<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-toolbar color="warning">
        <v-toolbar-title class="white-text">
          <span class="white--text">Bilanço Format Sil</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text class="blockquote">
          {{ $t('Are-you-sure-want-delete') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="deleteDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn outline color="info" @click="deleteFormat()">  {{ $t('Delete') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDataDialog" max-width="400px">
      <v-toolbar color="info">
        <v-toolbar-title class="white-text">
          <span v-if="this.updateStatus==1" class="white--text">Bilanço Formatı Düzenle</span>
          <span v-if="this.updateStatus==0" class="white--text">Bilanço Formatı Ekle</span>
        </v-toolbar-title>
      </v-toolbar>
      <v-card color="white">
        <v-card-text>
          <!-- <v-text-field
            v-model="formatData.LineNumber"
            label="Satır"
          ></v-text-field> -->
          <v-text-field
            v-model="formatData.Kebir"
            label="Kebir"
          ></v-text-field>
          <v-text-field
            v-model="formatData.Explanation"
            label="Açıklama"
          ></v-text-field>
        
          <v-radio-group  v-model="formatData.Ap">
  <v-radio label="Aktif" value='A'></v-radio>
  <v-radio label="Pasif" value='P'></v-radio>
 
</v-radio-group>
          <v-radio-group  v-model="formatData.DeptCredit">
  <v-radio label="Borç" :value="false"></v-radio>
  <v-radio label="Alacak" :value="true"></v-radio>
 
</v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="editDataDialog = false" outline color="warning">
            {{$t('Cancel')}}
          </v-btn>
          <v-btn v-if="this.updateStatus==1" outline color="info" @click="updateFormat()"> {{ $t('Update') }} </v-btn>
          <v-btn v-if="this.updateStatus==0" outline color="info" @click="addFormat()"> {{ $t('Add') }} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Bilanço Format</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>
            <v-spacer></v-spacer>

<v-tooltip bottom>
  <!-- :disabled="!sayfayetki.Save" -->
  <v-btn slot="activator" @click="AddLine()" flat>
    <span class="hidden-sm-and-down">
      <span class="hidden-sm-and-down">Satır Ekle</span>
    </span>
    <v-icon right dark>add_box</v-icon>
  </v-btn>
  <!-- <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
  <span v-if="sayfayetki.Save">Banka Pos Ekle</span> -->
</v-tooltip>
            <v-menu offset-y>
              <!-- <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title
                    >Html {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>

                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list> -->
            </v-menu>
          </v-toolbar>
        </v-flex>


        <v-container fluid="">
          <v-card color="grey lighten-5" flat>
           
            <v-layout>
              <v-flex xs12 sm12 md12 pt-2>
                <v-card flat>
                  <v-data-table
                    :headers="headers"
                    class="elevation-1"
                    :rows-per-page-items="[50, 100, 250, 500]"
                    :items="items"
                    :search="search"
                  >
                    <template slot="items" slot-scope="props">
                      <tr item>
                        <!-- <td class="text-xs-left">
                        {{ props.item.LineNumber  }}
                      </td> -->
                      <td class="text-xs-left">
                        {{ props.item.Explanation }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Kebir }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Ap }}
                      </td>
                      <td class="text-xs-left" v-if="props.item.DeptCredit">
                       Alacak
                      </td>
                      <td class="text-xs-left" v-else>
                       Borç
                      </td>
                      <td class="justify-start layout px-0">
        
          <v-btn
                
                @click="editDialogOpen(props.item)"
                icon
                small
                flat
              >
                <v-icon color="info">edit</v-icon>
              </v-btn>
              <v-btn
                
                @click="deleteDialogOpen(props.item)"
                icon
                small
                flat
              >
                <v-icon color="info">delete</v-icon>
              </v-btn>
        </td>
                      </tr>
                    
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "../../customcomp/tarihim";
import auth from "../../../../api/auth";
import catimuhasebekodu from "../comp/catimuhasebekodu.vue";

export default {
  data() {
    return {
      updateStatus:0,
      aktifPasifler:[
    {
          text: "Aktif",
          value:'A'
     },
     {
          text: "Pasif",
          value:'P'
     },
   
    ],
    deleteDialog:false,
      editDataDialog:false,
      formatData: {
        Ap: '',
        CompanyID: 0,
        DeptCredit: false,
        Explanation: '',
        ID: 0,
        Kebir:'0',
        LineNumber:'0'
      },
    dovizTipleri:[
    {
          text: "TL",
          value:0
     },
     {
          text: "Döviz",
          value:1
     },
     {
          text: "Döviz + TL",
          value:3
     },
    ],
      dialogfiltre:false,
      search: null,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      valid: true,
      
     
     
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      items: [],
     
    
    
      headers: [
        // {
        //   text: 'Satır',
        //   value: 'LineNumber'
        // },
        {
          text: 'Açıklama',
          value: 'Explanation',
          sortable: false
        },
        {
          text: 'Kebir',
          value: 'Kebir',
          sortable: false
        },
        {
          text: 'Aktif/Pasif',
          value: 'Ap',
          sortable: false
        },
        {
          text: 'Borç/Alacak',
          value:'DeptCredit',
          sortable: false
        },
        {
          text: 'İşlem',
          sortable: false
        },
      ],
    };
  },
  methods: {
   
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
   
    getparabirimi() {
      return helpers.getparabirimi();
    },
    AddLine(){
       this.updateStatus=0;
       this.formatData.Ap="A";
       this.formatData.DeptCredit=false;
       this.formatData.Explanation='';
       this.formatData.LineNumber=null;
       this.formatData.Kebir=null;
       this.editDataDialog=true;
    },
    deleteDialogOpen(val) {
     
      this.formatData=val;
      this.deleteDialog=true;
    },
    editDialogOpen(val) {
      this.updateStatus=1;
      this.formatData=val;
      this.editDataDialog=true;
    },
    addFormat()
    {
      this.loadingvmodel = true;
      this.formatData.ID=this.formatData.LineNumber;
      this.formatData.CompanyID=this.credentials.MuhasebeSirketNo;
      let params = {
        Update: 0,
        UserID:this.credentials.UserID,
        Line:this.formatData
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/StatementLineSave",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
           
            this.text1 = response.body.ResponseMessage;
            this.snackbar = true;
            this.getList();
            this.editDataDialog = false;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-StatementLineSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-StatementLineSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    updateFormat()
    {
      this.loadingvmodel = true;
      this.formatData.CompanyID=this.credentials.MuhasebeSirketNo;
      let params = {
        Update: 1,
        UserID:this.credentials.UserID,
        Line:this.formatData
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/StatementLineSave",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
           
            this.text1 = response.body.ResponseMessage;
            this.snackbar = true;
            this.getList();
            this.editDataDialog = false;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-StatementLineSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-StatementLineSave";
              this.snackbar = true;
              this.editDataDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
    deleteDialogOpen(val) {
      this.formatData=val;
     this.deleteDialog=true;
    },
    deleteFormat()
    {
      this.loadingvmodel = true;
      let params = {
        
        UserID:this.credentials.UserID,
        StatementLineId:this.formatData.ID
      };
      this.$http
        .post(
          auth.API_URL + "api/AccountingReports/StatementLineDelete",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
           
            this.text1 = response.body.ResponseMessage;
            this.snackbar = true;
            this.getList();
            this.deleteDialog = false;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-StatementLineDelete";
              this.snackbar = true;
              this.deleteDialog = false;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-StatementLineDelete";
              this.snackbar = true;
              this.deleteDialog = false;
              this.loadingvmodel = false;
            }
          }
        );
    },
   
   
    getList() {
      let params = {
      
        CompanyID: this.credentials.MuhasebeSirketNo,
        UserID:this.credentials.UserID
      };
     
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/StatementLineList",
              params,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {

               this.items=response.body.lines;
              
               console.log(this.items);
               
                
              },
              (response) => {
                if (response.status === 0) {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                } else {
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                }
              }
            );
        
     
    },
  
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp,
    catimuhasebekodu,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    this.getList();
    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;

    //           window.open(url, "_self");
    //         } else {
    //           var mainUrl = "#/";
    //           window.open(mainUrl, "_self");
    //         }
    //       }
    //     });
    // }
  },
};
</script>

<style>
</style>

